import { Col, Row } from "antd";
import EnrollmentTrendChart from "./EnrollmentTrendChart";
import LearnersProgressChart from "./LearnersProgressChart";
import MetricCards from "./MetricCards";
import RevenueOverviewChart from "./RevenueOverviewChart";
import TopPlacesTable from "./TopPlacesTable";

export default function Analytics() {
  return (
    <div className="space-y-6">
      {/* Metric Cards Section */}
      <MetricCards />

      {/* Charts Section 1 */}
      <Row gutter={[24, 24]}>
        <Col span={24} lg={12}>
          <EnrollmentTrendChart />
        </Col>
        <Col span={24} lg={12}>
          <RevenueOverviewChart />
        </Col>
      </Row>

      {/* Charts Section 2 & Top Places */}
      <Row gutter={[24, 24]}>
        <Col span={24} lg={12}>
          <LearnersProgressChart />
        </Col>
        <Col span={24} lg={12}>
          <TopPlacesTable />
        </Col>
      </Row>
    </div>
  );
}
